import { Observable } from 'rxjs';
import { StatusCheckService } from './../status-check.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-retry',
  templateUrl: './retry.component.html',
  styleUrls: ['./retry.component.css']
})
export class RetryComponent implements OnInit {
  @Input() message = 'Something went wrong.';
  @Output() tryAgain = new EventEmitter<boolean>();
  constructor(private status: StatusCheckService) {}

  ngOnInit(): void {}

  emitTryAgain() {
    this.tryAgain.emit(true);
  }

  get isOnline$(): Observable<boolean> {
    return this.status.online$;
  }
}
